(function () {
  'use strict';
  if (window.Shopify && Shopify.designMode) return;
  var nodes = document.querySelectorAll('[data-sondos-pdp-video]');
  if (!nodes.length || !('IntersectionObserver' in window)) return;

  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var holdBack = reduce || !!conn.saveData || /^(slow-)?2g$/.test(conn.effectiveType || '');

  function label(el, playing) {
    var btn = el.querySelector('[data-sondos-pdp-toggle]');
    if (!btn) return;
    var text = playing ? el.getAttribute('data-label-pause') : el.getAttribute('data-label-play');
    btn.setAttribute('aria-label', text || '');
    btn.setAttribute('data-state', playing ? 'playing' : 'idle');
  }

  function clock(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    var s = Math.floor(sec % 60);
    var m = Math.floor(sec / 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function paint(scrub, current, duration) {
    if (!scrub) return;
    var fill = scrub.querySelector('[data-sondos-pdp-fill]');
    var time = scrub.querySelector('[data-sondos-pdp-time]');
    var ratio = duration > 0 ? Math.min(1, Math.max(0, current / duration)) : 0;
    if (fill) fill.style.transform = 'scaleX(' + ratio + ')';
    if (time) time.textContent = duration > 0 ? clock(current) + ' / ' + clock(duration) : clock(current);
    scrub.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
  }

  function ratioFromEvent(scrub, ev) {
    var track = scrub.querySelector('[data-sondos-pdp-fill]');
    var box = (track && track.parentElement ? track.parentElement : scrub).getBoundingClientRect();
    if (!box.width) return 0;
    return Math.min(1, Math.max(0, (ev.clientX - box.left) / box.width));
  }

  function bindScrub(scrub, getVideo) {
    if (!scrub || scrub.getAttribute('data-bound') === '1') return;
    scrub.setAttribute('data-bound', '1');
    var dragging = false;
    function seek(ev) {
      var v = getVideo();
      if (!v || !v.duration) return;
      var ratio = ratioFromEvent(scrub, ev);
      v.currentTime = ratio * v.duration;
      paint(scrub, v.currentTime, v.duration);
    }
    scrub.addEventListener('pointerdown', function (ev) {
      dragging = true;
      scrub.setPointerCapture(ev.pointerId);
      ev.preventDefault();
      ev.stopPropagation();
      seek(ev);
    });
    scrub.addEventListener('pointermove', function (ev) {
      if (!dragging) return;
      ev.preventDefault();
      ev.stopPropagation();
      seek(ev);
    });
    function end() { dragging = false; }
    scrub.addEventListener('pointerup', end);
    scrub.addEventListener('pointercancel', end);
    scrub.addEventListener('keydown', function (ev) {
      var v = getVideo();
      if (!v || !v.duration) return;
      var step = ev.key === 'ArrowRight' ? 1 : ev.key === 'ArrowLeft' ? -1 : 0;
      if (!step) return;
      ev.preventDefault();
      v.currentTime = Math.min(v.duration, Math.max(0, v.currentTime + step));
      paint(scrub, v.currentTime, v.duration);
    });
  }

  function watch(v, scrub) {
    function draw() { paint(scrub, v.currentTime, v.duration); }
    v.addEventListener('timeupdate', draw);
    v.addEventListener('loadedmetadata', draw);
    v.addEventListener('seeked', draw);
  }

  function teardown(el) {
    var v = el.querySelector('video');
    if (v) {
      v.pause();
      v.removeAttribute('src');
      v.load();
      v.remove();
    }
    el.classList.remove('is-playing');
    label(el, false);
    paint(el.querySelector('[data-sondos-pdp-scrub]'), 0, 0);
  }

  function openFull(el) {
    if (document.querySelector('.sondos-pdp-video-dialog')) return;
    var src = el.getAttribute('data-src');
    if (!src) return;
    teardown(el);
    el.setAttribute('data-manual', '1');
    var dialog = document.createElement('dialog');
    dialog.className = 'sondos-pdp-video-dialog';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'sondos-pdp-video-dialog__close';
    close.setAttribute('aria-label', el.getAttribute('data-label-close') || '');
    close.textContent = '\u00d7';
    var v = document.createElement('video');
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.loop = true;
    v.setAttribute('loop', '');
    v.preload = 'auto';
    v.controls = false;
    v.src = src;
    var shield = document.createElement('div');
    shield.className = 'sondos-pdp-video-dialog__shield';
    function lockBar(ev) {
      if (ev) ev.preventDefault();
      v.controls = false;
      v.removeAttribute('controls');
    }
    shield.addEventListener('touchstart', lockBar, { passive: false });
    shield.addEventListener('click', lockBar);
    var scrub = document.createElement('div');
    scrub.className = 'sondos-pdp-video-dialog__scrub';
    scrub.setAttribute('role', 'slider');
    scrub.setAttribute('tabindex', '0');
    scrub.setAttribute('aria-label', el.getAttribute('data-label-seek') || '');
    scrub.setAttribute('aria-valuemin', '0');
    scrub.setAttribute('aria-valuemax', '100');
    scrub.setAttribute('aria-valuenow', '0');
    var time = document.createElement('span');
    time.className = 'sondos-pdp-video__scrub-time';
    time.setAttribute('data-sondos-pdp-time', '');
    time.textContent = '0:00';
    var track = document.createElement('span');
    track.className = 'sondos-pdp-video__scrub-track';
    var fill = document.createElement('span');
    fill.className = 'sondos-pdp-video__scrub-fill';
    fill.setAttribute('data-sondos-pdp-fill', '');
    track.appendChild(fill);
    scrub.appendChild(time);
    scrub.appendChild(track);
    dialog.appendChild(v);
    dialog.appendChild(shield);
    dialog.appendChild(scrub);
    dialog.appendChild(close);
    var guard = setInterval(lockBar, 300);
    watch(v, scrub);
    bindScrub(scrub, function () { return v; });
    function shut() {
      if (dialog.getAttribute('data-shut') === '1') return;
      dialog.setAttribute('data-shut', '1');
      clearInterval(guard);
      v.pause();
      v.removeAttribute('src');
      v.load();
      if (dialog.open) dialog.close();
      dialog.remove();
      el.removeAttribute('data-manual');
      var slide = el.closest('.sondos-pdp-video-slide') || el;
      var r = slide.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) play(el);
    }
    close.addEventListener('click', shut);
    dialog.addEventListener('cancel', function (ev) {
      ev.preventDefault();
      shut();
    });
    document.body.appendChild(dialog);
    if (dialog.showModal) dialog.showModal();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function play(el) {
    if (el.getAttribute('data-manual') === '1') return;
    if (el.querySelector('video')) return;
    var src = el.getAttribute('data-src');
    if (!src) return;
    if (holdBack) return;
    var v = document.createElement('video');
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.loop = true;
    v.setAttribute('loop', '');
    v.preload = 'auto';
    v.disableRemotePlayback = true;
    v.setAttribute('aria-hidden', 'true');
    v.tabIndex = -1;
    v.addEventListener('playing', function () {
      el.classList.add('is-playing');
      label(el, true);
    });
    v.addEventListener('pause', function () {
      if (el.getAttribute('data-self-pause') === '1') return;
      teardown(el);
    });
    v.addEventListener('error', function () { teardown(el); });
    v.src = src;
    watch(v, el.querySelector('[data-sondos-pdp-scrub]'));
    el.appendChild(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { teardown(el); });
  }

  Array.prototype.forEach.call(nodes, function (el) {
    bindScrub(el.querySelector('[data-sondos-pdp-scrub]'), function () { return el.querySelector('video'); });
    var expand = el.querySelector('[data-sondos-pdp-expand]');
    if (expand) {
      expand.addEventListener('click', function () { openFull(el); });
    }
    var btn = el.querySelector('[data-sondos-pdp-toggle]');
    if (btn) {
      btn.addEventListener('click', function () {
        var v = el.querySelector('video');
        if (v && !v.paused) {
          el.setAttribute('data-manual', '1');
          el.setAttribute('data-self-pause', '1');
          v.pause();
          el.removeAttribute('data-self-pause');
          teardown(el);
          return;
        }
        el.removeAttribute('data-manual');
        play(el);
      });
    }
    var seen = false;
    var slide = el.closest('.sondos-pdp-video-slide') || el;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          seen = true;
          play(el);
        } else if (seen) teardown(el);
      });
    }, { threshold: 0.6, rootMargin: '0px' });
    io.observe(slide);
    if (slide.clientWidth > 0) play(el);
  });
})();
